import { paths } from '@/constants/paths';
import { Role } from '@/models/AccountEnums';
import { dashboardApi } from '@/store/dashboardApi';
import type { WARootState } from '@/store/store';
import { normalizePath } from '@/utils/appMenuFilter';
import { AdvisorWidgetCodes } from '@/widget-mappings/AdvisorWidgetMap';

const WIDGET_CODE_BY_ROUTE: Record<string, string | undefined> = {
  [normalizePath(paths.advisor.resources)]: AdvisorWidgetCodes.Resources,
};

export const ADVISOR_WIDGET_DASHBOARD = { dashboardName: 'home' };

export const advisorWidgetCodeForRoute = (pathname: string) =>
  WIDGET_CODE_BY_ROUTE[normalizePath(pathname)];

export const isWidgetInList = (
  widgets: { Records?: readonly { Code: string }[] | null } | undefined,
  widgetCode: string,
) => widgets?.Records?.some((widget) => widget.Code === widgetCode) ?? false;

type DashboardWidgetsCacheState = Parameters<
  ReturnType<typeof dashboardApi.endpoints.getDashboardWidgets.select>
>[0];

export const selectIsAdvisorWidgetRouteGranted = (
  state: WARootState,
  pathname: string,
) => {
  if (state.auth.currentRole !== Role.Advisor) return false;
  const widgetCode = advisorWidgetCodeForRoute(pathname);
  if (!widgetCode) return false;
  const cacheState = state as WARootState & Partial<DashboardWidgetsCacheState>;
  if (cacheState[dashboardApi.reducerPath] === undefined) return false;
  const { data } = dashboardApi.endpoints.getDashboardWidgets.select(
    ADVISOR_WIDGET_DASHBOARD,
  )(cacheState as DashboardWidgetsCacheState);
  return isWidgetInList(data, widgetCode);
};
